// extracted by mini-css-extract-plugin
module.exports = {"section":"_1_Ag_","carousel":"_13R2T","tightPadding":"_3HfFe","isEmpty":"_1FUFg","dark":"N07hN"};